import { getSiteRecceById } from '@api/services/site-recce.service';
import useDataQuery from '@hooks/use-data-query';

const useSiteRecceData = (clientInstallationId: string, projectInstallationId: string, siteRecceId: string) => {
    const siteRecceQuery = useDataQuery(
        ['site-recce', clientInstallationId, projectInstallationId, siteRecceId],
        () => getSiteRecceById(clientInstallationId, projectInstallationId, siteRecceId),
        {
            enabled: Boolean(clientInstallationId && projectInstallationId && siteRecceId),
        }
    );

    return {
        isLoading: siteRecceQuery.isLoading,
        siteRecce: siteRecceQuery.data,
        setData: siteRecceQuery.setData,
    };
};

export default useSiteRecceData;
